export default __webpack_public_path__ + "static/media/delete_approved_sp.3959e288.svg";